module.exports = __webpack_public_path__ + "static/media/phd_thesis_math_tools.0d9b85e2.png";